module.exports = __webpack_public_path__ + "img/3-4.aff93d7b.png";